require('../../modules/es6.array.iterator');
module.exports = require('../../modules/_core').Array.values;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toolbox/node_modules/core-js/fn/array/iterator.js
// module id = 594
// module chunks = 0